import { create } from 'zustand';

// Transient UI state for an in-flight language switch. Deliberately NOT
// persisted (unlike its sibling useLocaleStore): a reload mid-switch lands on
// the boot path, which loads the persisted locale itself — a rehydrated
// "switching" flag would show an overlay nothing will ever dismiss.
//
// `pendingLocale` doubles as the boolean: null means idle, a locale code means
// the app-wide LocaleSwitchOverlay is up and switchLocale() is driving the
// resource load + post-clear refetches. Written only by switchLocale — see
// modules/Common/utils/switchLocale.js for the sequencing.
export const useLocaleSwitchStore = create((set) => ({
  pendingLocale: null,
  begin: (code) => set({ pendingLocale: code }),
  finish: () => set({ pendingLocale: null }),
}));
